import { render, staticRenderFns } from "./productNews.vue?vue&type=template&id=f2894a10&scoped=true&"
import script from "./productNews.vue?vue&type=script&lang=js&"
export * from "./productNews.vue?vue&type=script&lang=js&"
import style0 from "./productNews.vue?vue&type=style&index=0&id=f2894a10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2894a10",
  null
  
)

export default component.exports